import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControllerButtonCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="controller-button-circle, confirm, select, accept, continue"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="4.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconControllerButtonCircle;
